import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import WhatsAppFab from "../components/WhatsAppFab";
import SEO from "../components/SEO";
import Hero from "../components/sections/Hero";
import BrandMarquee from "../components/sections/BrandMarquee";
import Services from "../components/sections/Services";
import Projects from "../components/sections/Projects";
import ViralWorks from "../components/sections/ViralWorks";
import BTS from "../components/sections/BTS";
import About from "../components/sections/About";
import Process from "../components/sections/Process";
import Testimonials from "../components/sections/Testimonials";
import CTA from "../components/sections/CTA";
import Contact from "../components/sections/Contact";
import { useSettings, useServices } from "../lib/queries";
import { useLang } from "../lib/i18n";

export default function Home() {
  const { data: settings } = useSettings();
  const { data: services = [] } = useServices();
  const { lang } = useLang();

  const jsonLd = settings
    ? [
        {
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "İxirli Reklam & Prodüksiyon",
          "alternateName": "Ixirli",
          "url": typeof window !== "undefined" ? window.location.origin : "",
          "logo": settings.hero_image,
          "description": settings.seo_description,
          "email": settings.email,
          "telephone": settings.phone,
          "sameAs": [settings.instagram, settings.youtube].filter(Boolean),
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Gaziantep",
            "addressCountry": "TR",
          },
        },
        {
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "@id": (typeof window !== "undefined" ? window.location.origin : "") + "/#business",
          "name": "İxirli Reklam & Prodüksiyon",
          "image": settings.hero_image,
          "priceRange": "$$",
          "telephone": settings.phone,
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Gaziantep",
            "addressCountry": "TR",
          },
          "areaServed": "Türkiye",
        },
        {
          "@context": "https://schema.org",
          "@type": "WebSite",
          "url": typeof window !== "undefined" ? window.location.origin : "",
          "name": "İxirli Reklam & Prodüksiyon",
          "inLanguage": ["tr-TR", "en-US"],
          "potentialAction": {
            "@type": "SearchAction",
            "target": (typeof window !== "undefined" ? window.location.origin : "") + "/?q={search_term_string}",
            "query-input": "required name=search_term_string",
          },
        },
        {
          "@context": "https://schema.org",
          "@type": "ItemList",
          "name": "Hizmetler",
          "itemListElement": services.map((s, i) => ({
            "@type": "Service",
            "position": i + 1,
            "name": s[`title_${lang}`] || s.title_tr,
            "description": s[`description_${lang}`] || s.description_tr,
            "provider": { "@type": "Organization", "name": "İxirli" },
          })),
        },
      ]
    : null;

  const title = settings?.[`seo_title`] || "İxirli Reklam & Prodüksiyon — Markanızı Unutulmaz Yapıyoruz";
  const desc = settings?.[`seo_description`] || "";

  return (
    <>
      <SEO title={title} description={desc} lang={lang} image={settings?.hero_image} jsonLd={jsonLd} />
      <Header />
      <main>
        <Hero />
        <BrandMarquee />
        <Services />
        <Projects />
        <ViralWorks />
        <BTS />
        <About />
        <Process />
        <Testimonials />
        <CTA />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFab />
    </>
  );
}
